import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../../../globals";
import useEsTelefono from "../../../../utils/esTelefono";
import { ScheduleCatalogService } from "../../../../services/v2/scheduleCatalog.service";
import logoHorizontal from "../../../../assets/images/wa-horizontal-color.png";
import { montarCatalogo } from "./catalogoHorarios";
import "./catalogoHorarios.css";

const servicio = new ScheduleCatalogService();

/**
 * Catálogo de Horarios (Administración): la misma pantalla de horarios.washingtonacademy.com.
 * Todo el catálogo lo pinta catalogoHorarios.ts (copia del sitio); aquí solo se le da dónde
 * vivir, de dónde sacar los datos y en qué plantel abrir.
 */
const ScheduleCatalogController: React.FC = () => {
	const movil = useEsTelefono();
	const sessionCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
	const legacyCampusKey: any = useSelector((state: RootState) => state.currentUserCampus.value);
	const legacyCampusRef: any = useSelector((state: RootState) => state.campusRef.value);
	const legacyCampus: any = legacyCampusKey && legacyCampusRef ? legacyCampusRef[legacyCampusKey] : null;
	//El plantel de la barra manda; el de la sesión solo si no hay barra (2026-09-24).
	const campusId: number | null = legacyCampus?.id ?? sessionCampus?.id ?? null;
	const lienzo = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (campusId === null || lienzo.current === null) {
			return;
		}
		return montarCatalogo(lienzo.current, {
			cargar: () => servicio.catalogue(campusId).then((r) => r.data),
			registrarCopia: (datos: any) => { servicio.logCopy(campusId, datos).catch(() => undefined); },
			plantelInicial: campusId,
			logo: logoHorizontal
		});
	}, [campusId]);

	if (campusId === null) {
		return <React.Fragment />;
	}
	return (
		<div className="container-fluid waModulo" style={{ textAlign: "left", padding: movil ? "10px 12px 0 12px" : "10px 24px 0 24px" }}>
			<h4 style={{ margin: "0 0 8px 0" }}>Catálogo de Horarios</h4>
			<div className="waCatalogoHorarios" ref={lienzo} />
		</div>
	);
};

export default ScheduleCatalogController;
